import { TPolicyLinkBlock } from '@/components/policyLinkBlock/types'
import { getPolicy } from '@/components/policyLinkBlock/utils'
import { TextHTML } from '@/components/typography'

const defaultPolicyTemplate: TPolicyLinkBlock = {
  text: 'By continuing, you agree to our<br> {tos} and {refundPolicy}.',
  tos: 'Terms of Service',
  refundPolicy: 'Refund Policy',
}

export const FooterPolicy = () => {
  const policyText = getPolicy({
    translationKey: 'footer.policyLinkBlock',
    defaultPolicyTemplate: defaultPolicyTemplate,
  })
  return (
    <div className="policy-container">
      <TextHTML title={policyText} />
    </div>
  )
}
